//@flow

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';

import { CardBodyBottom, CardBodyTop } from './Common';

type Props = {
  cardData: {
    name: string,
    startingPrice: {
      currency: string,
      amount: number,
    },
    url: string,
    imageUrl: string,
  },
};

export default class TransportCard extends Component<Props> {
  render() {
    const { cardData } = this.props;
    const {
      name,
      startingPrice: { currency, amount },
    } = cardData;
    return (
      <Card className="lodgeCard">
        <Link to={cardData.url}>
          <div className="cardImage">
            <picture>
              <img alt={name} src={cardData.imageUrl} />
            </picture>
          </div>
          <div className="card-body">
          <CardBodyTop title={name} type="transport" url={cardData.url}>
            <div className="location">
              <ul>
                <li>*24/7 customer support</li>
                <li>*Free 48 hours cancellation</li>
              </ul>
            </div>
          </CardBodyTop>

          <CardBodyBottom>
          <div className="rating"></div>
            <div className="price">
              <small>From</small>
              <p>
                {currency} {amount}
              </p>
            </div>
          </CardBodyBottom>
          </div>
        </Link>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cards/TransportCard.jsx